// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tirdMenuItem-module--wrapper--2U-P1","listItem":"tirdMenuItem-module--listItem--1ZLKC"};